import AnimatedNumber from './animatedNumber'

export default AnimatedNumber
